import {useEffect} from 'react';

export function useEditorPrefetchFancyTextMobileModules(): void {
  useEffect((): void => {
    void prefetchFancyTextModules();
  }, []);

  const prefetchFancyTextModules = async (): Promise<void> => {
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-fancy-text-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-fancy-text-effect-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-fancy-text-colors-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-fancytext-shape-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-fancy-text-fonts-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-shadow-panel');
  };
}
